import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { OfferCard } from "@/pages/OffersPage";
import { SectionHeading } from "@/components/Reveal";
import Carousel from "@/components/Carousel";

// Homepage strip of featured offers. Renders nothing when no published featured offers exist.
export const FeaturedOffers = () => {
  const [offers, setOffers] = useState(null);

  useEffect(() => {
    api.get("/offers").then(({ data }) => setOffers((data || []).filter((o) => o.featured).slice(0, 6))).catch(() => setOffers([]));
  }, []);

  if (!offers || offers.length === 0) return null;

  return (
    <section className="relative border-b border-slate-200 bg-white py-20 sm:py-24" data-testid="featured-offers">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex items-end justify-between gap-4">
          <SectionHeading caption="لفترة محدودة" title="عروض سفر مميزة" />
          <Link to="/offers" data-testid="featured-offers-all" className="mb-2 hidden sm:inline-flex items-center gap-2 rounded-full border border-slate-200 px-6 py-2.5 text-xs font-bold text-slate-600 transition-colors hover:border-[#C80000]/50 hover:text-[#C80000]">
            كل العروض <ArrowLeft className="h-3.5 w-3.5" />
          </Link>
        </div>
        <div className="mt-10">
          <Carousel items={offers} testid="offers-carousel" ariaLabel="معرض عروض السفر المميزة"
            renderItem={(o) => <OfferCard o={o} />} />
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link to="/offers" className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-6 py-2.5 text-xs font-bold text-slate-600">كل العروض <ArrowLeft className="h-3.5 w-3.5" /></Link>
        </div>
      </div>
    </section>
  );
};
